<div class="modal-container">

    <div class="icon">
        <svg xmlns="http://www.w3.org/2000/svg" width="76" height="76" viewBox="0 0 76 76" fill="none">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M0.653809 38C0.653809 17.3741 17.3744 0.653564 38.0002 0.653564C58.6264 0.653564 75.3467 17.3742 75.3467 38C75.3467 58.6261 58.6264 75.3464 38.0002 75.3464C17.3744 75.3464 0.653809 58.6261 0.653809 38ZM38.0002 6.35356C20.5224 6.35356 6.35381 20.5222 6.35381 38C6.35381 55.4781 20.5224 69.6464 38.0002 69.6464C55.4783 69.6464 69.6467 55.4781 69.6467 38C69.6467 20.5221 55.4783 6.35356 38.0002 6.35356Z" fill="#1F5434"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M55.2615 23.8334C56.4906 24.8167 56.6899 26.6102 55.7066 27.8393L34.478 54.375C33.5164 55.577 31.774 55.7982 30.5425 54.8746L19.9283 46.9139C18.669 45.9695 18.4138 44.1831 19.3583 42.9239C20.3027 41.6647 22.089 41.4095 23.3483 42.3539L31.7527 48.6572L51.2556 24.2785C52.2389 23.0494 54.0324 22.8502 55.2615 23.8334Z" fill="#1F5434"/>
        </svg>
    </div>

    <div>
        <h2 mat-dialog-title>Enviamos tus links de pago</h2>
        <mat-dialog-content>
            <p>
                Revisa tu correo {{ data.censoredMail }}<br>
                Si necesitas actualizar tu correo comunícate a Servicio al Cliente <strong><a>servicioalcliente&#64;totalabogados.cl</a></strong> o llamando al <strong>+56 9 34297464</strong>
            </p>
        </mat-dialog-content>
    </div>


    <mat-dialog-actions align="end" class="dialog-actions">
        <button mat-button color="primary" (click)="dialogRef.close('redirect')">Ir a TotalAbogados.cl</button>
        <a class="simple-btn" (click)="dialogRef.close('resend')">Enviar nuevamente</a>
    </mat-dialog-actions>

</div>